import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { useGetSdkVersionsQuery } from '../../api/sdkVersionApiSlice';
import { Loader } from '../components';
import { OsIcon } from '../OsIcon';
import FilterButton, { FilterGroup } from '../FilterButton';
import Table from '../tables/Table';
import useCustomTable from '../tables/useCustomTable';
import Title from '../Title';
import Block from '../Block';
import { Badge } from 'react-bootstrap';
import Pagination from '../tables/Pagination';

const SdkVersionList = () => {
  const { t, i18n } = useTranslation();
  const {
    tableProps,
    paginationProps,
    tableFilterProps,
    tableSearchProps
  } = useCustomTable({
    sortable: true,
    paginate: true,
    sortBy: {name: 'asc'}
  });
  const {filters, setAllFilters} = tableFilterProps
  const history = useHistory();
  const {data, isLoading, isSuccess, isError, refetch} = useGetSdkVersionsQuery()


  const columns = useMemo(() => [{
    Header: t("sdkVersion.version"),
    accessor: 'version',
  },{
    Header: t("sdkVersion.os"),
    accessor: 'os',
    Cell: ({row}) => (<OsIcon os={row.original.os} />)
  },{
    Header: t("sdkVersion.changeLog"),
    accessor: 'changeLog',
    Cell: ({row}) => (row.original.changeLog ? <Badge variant="success">{"Ok"}</Badge> : <Badge variant="danger">{"Missing"}</Badge>),
  },{
    Header: t("sdkVersion.environment"),
    accessor: 'environment',
  },{
    Header: t("sdkVersion.testedAt"),
    accessor: 'testedAt',
    format: 'date'
  },{
    Header: t("sdkVersion.productionAt"),
    accessor: 'productionAt',
    format: 'date'
  }]);

  const showVersion = (rowData) => history.push(`sdk_versions/${rowData.slug}`)

  return ( <>
    <Title main={"SDK Version"}/>
    <FilterGroup {...tableFilterProps}>
      <FilterButton
          title={t("sdkVersion.environment")}
          options={["Test", "Production"]}
          search={false}
          includeAll={true}
          name="environment"/>
      <FilterButton
          title={t("sdkVersion.os")}
          options={["ios", "android"]}
          search={false}
          includeAll={true}
          name="os"/>
    </FilterGroup>
    <Block className="mb-0">
      <Loader success={!isLoading && isSuccess} error={!isLoading && !isSuccess} retry={refetch}>
        <Table
          noPadding
          data={data}
          columns={columns}
          {...tableProps}
          initialFilters={filters}
          onRowClick={showVersion} />
      </Loader>
    </Block>
    <Pagination {...paginationProps}/>
  </>
  )
}

export default SdkVersionList;